import axios from 'axios';

// When mock API is enabled, use relative paths so MSW can intercept requests
// Otherwise, use the configured API URL (backend at localhost:8081)
const isMockEnabled = process.env.REACT_APP_ENABLE_MOCK_API === 'true';
const API_BASE_URL = isMockEnabled
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:8081');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('cms_auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('cms_auth_token');
      localStorage.removeItem('cms_auth_user');

      // Redirect to login if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
